'use client';

import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { HeroHeaderBlock } from '@components/v3/organisms/hero-header-block';
import { Locale } from '@core/constants/locales.constants';
import { HeaderBlocksHero } from '@graphql/__generated__/graphql';
import { Translations } from '@lib/dictionary-keys/__generated__';
import heroHeaderBlockTransform from '@utils/transforms/components/organisms/heroHeaderBlock.transform';

export type RenderHeroHeaderBlockProps = {
  locale: Locale;
  props: CleanContentful<HeaderBlocksHero>;
  dictionary: {
    readNewsArticle: Translations['news']['label']['readNewsArticle'];
    viewGalleryArticle: Translations['news']['label']['viewGalleryArticle'];
    watchVideoArticle: Translations['news']['label']['watchVideoArticle'];
    sponsoredBy: Translations['common']['label']['sponsoredBy'];
    previousAction: Translations['common']['action']['previous'];
    nextAction: Translations['common']['action']['next'];
    membersOnly: Translations['articleCard']['label']['membersOnly'];
  };
  classNames?: string[];
};

const RenderHeaderBlock = ({
  props,
  locale,
  dictionary,
  classNames,
}: RenderHeroHeaderBlockProps) => (
  <HeroHeaderBlock
    classNames={classNames}
    {...heroHeaderBlockTransform(props, locale, {
      ...dictionary,
    })}
  />
);

export default RenderHeaderBlock;
